import { TextField } from "@mui/material";
import { useContext, useState } from "react";
import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";
import { AuthContext } from "../../../Context/AuthContext";

export default function RemarkHomework({ editData, setRefetch }) {
  const { t } = useContext(AuthContext);

  const { handleSubmit } = useCheckStudentHomework({ setRefetch });
  const [value, setValue] = useState(editData?.remark || "");

  const handleSubmitValue = (e) => {
    const value = e.target.value || "";
    if (value !== editData?.remark) {
      handleSubmit({
        id: editData?._id,
        remark: value,
      });
    }
  };

  // const isDisabled = !editData?.status || editData?.status === "empty";

  return (
    <TextField
      fullWidth
      size="small"
      multiline
      className="text-field"
      placeholder={t("thead_reason")}
      // disabled={isDisabled}
      value={value}
      onBlur={handleSubmitValue}
      onChange={(e) => setValue(e.target.value)}
      sx={{
        "& .MuiInputBase-input": {
          textAlign: "center",
          minWidth: 120,
        },
      }}
    />
  );
}
